import React, { useState, useEffect } from "react";
import { Button, Table, message } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { getList } from "../../../actions/dataActions";
import { connect } from "react-redux";
import SubGroupsModal from "./SubGroupsModal";
import DeleteConfirm from "./DeleteConfirm";
import axios from "axios";

const SubGroups = ({ getGroups, getSubGroups, list, MAINGROUPS }) => {
  const [isModalVisible, setModalVisible] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const deleteHandler = async (id) => {
    try {
      await axios.delete("/api/subgroup/" + id);
      message.success("Subgroup deleted successfully.");
      getSubGroups();
    } catch (err) {
      message.error("Error deleting subgroup.");
    }
  };

  useEffect(() => {
    getGroups();
    getSubGroups();
  }, [getGroups, getSubGroups]);

  const columns = [
    {
      title: "Subgroups",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      width: 150,
      render: (value, record) => {
        return (
          <>
            <div className="flex">
              <DeleteConfirm
                id={record.id}
                handleDelete={deleteHandler}
                title={record.name}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<DeleteOutlined />}
                  danger
                />
              </DeleteConfirm>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Button
        style={{ marginBottom: "1rem" }}
        onClick={showModal}
        type="primary"
      >
        <PlusOutlined /> Add SubGroups
      </Button>
      <Table dataSource={list} columns={columns} rowKey="id" />
      <SubGroupsModal
        getSubGroups={getSubGroups}
        MAINGROUPS={MAINGROUPS}
        isModalVisible={isModalVisible}
        setModalVisible={setModalVisible}
      />
    </>
  );
};

const mapState = (state) => ({
  MAINGROUPS: state.data.grouplist,
  list: state.data.subgrouplist,
});

const mapDispatch = {
  getGroups: () => getList("groups"),
  getSubGroups: () => getList("subgroups"),
};

export default connect(mapState, mapDispatch)(SubGroups);